import { Cart, CartItemCustomization } from '../../../app/data/models/cart';

export const calculateCartTotals = (
  cart: Cart,
  priceIncludesTax: boolean
): Cart => {
  const subtotal = cart.orderItems.reduce(
    (sum, item) => sum + item.totalPrice,
    0
  );
  const totalQuantity = cart.orderItems.reduce(
    (sum, item) => sum + item.quantity,
    0
  );

  let totalTax = 0;
  let totalPrice = 0;

  if (priceIncludesTax) {
    totalTax = cart.orderItems.reduce((sum, item) => {
      const taxRate = item.taxRate ?? cart.defaultTaxRate ?? 0;
      const itemTax = item.totalPrice - item.totalPrice / (1 + taxRate / 100);
      return sum + itemTax;
    }, 0);
    totalPrice = subtotal;
  } else {
    totalTax = cart.orderItems.reduce((sum, item) => {
      const taxRate = item.taxRate ?? cart.defaultTaxRate ?? 0;
      const itemTax = item.totalPrice * (taxRate / 100);
      return sum + itemTax;
    }, 0);
    totalPrice = subtotal + totalTax;
  }

  return {
    ...cart,
    subtotal,
    totalQuantity,
    totalTax,
    totalPrice,
  };
};

export const generateCartItemId = (
  mealItemId: string,
  customizations: CartItemCustomization[]
): string => {
  if (!customizations?.length) return mealItemId.toString();

  const customizationsString = customizations
    .map(
      (c) =>
        `${c.id}:${c.options.map((o) => `${o.id}-${o.quantity}`).join(',')}`
    )
    .join(';');

  return `${mealItemId}-${customizationsString}`;
};
